export default __webpack_public_path__ + "static/media/Amazon Kindle Fire HD 8.9.8399f169.png";